import { Component, OnInit, inject } from '@angular/core';
import { PrimeNG } from 'primeng/config';
import { AuthService, MemberService, MenuDataService } from 'shared';
import { RouterOutlet } from '@angular/router';
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    imports: [RouterOutlet]
})
export class AppComponent implements OnInit {
  private PrimeNG = inject(PrimeNG);
  private menuDataService = inject(MenuDataService);
  private memberService = inject(MemberService);
  private authService = inject(AuthService);

  model: any = [
    {
      label: '',
      icon: 'pi pi-fw pi-sitemap',
      items: [
        {
          label: 'Πίνακας Ελέγχου',
          icon: 'pi pi-fw pi-home',
          routerLink: [''],
        },
        {
          label: 'Ημερολόγιο Ραντεβού',
          icon: 'pi pi-fw pi-calendar',
          routerLink: ['/calendar'],
        },
        {
          label: 'Ασθενείς',
          icon: 'pi pi-fw pi-users',
          routerLink: ['/manage-patients'],
        },
        {
          label: 'Επισκέψεις',
          icon: 'pi pi-fw pi-clock',
          routerLink: ['/manage-visits'],
        },
        {
          label: 'Ιατροί',
          icon: 'pi pi-fw pi-wave-pulse',
          routerLink: ['/manage-doctors'],
        },
        {
          label: 'Εξετάσεις',
          icon: 'pi pi-fw pi-file',
          routerLink: ['/manage-exams'],
        },
        {
          label: 'Συνταγές/Παραπεμπτικά',
          icon: 'pi pi-fw pi-heart',
          routerLink: ['/prescriptions'],
        },
        // {
        //   label: 'Ρυθμίσεις',
        //   icon: 'pi pi-fw pi-cog',
        //   routerLink: ['***'],
        // },
      ],
    },
  ];

  ngOnInit(): void {
    this.PrimeNG.ripple.set(true);
    this.menuDataService.update(this.model);
    this.memberService.appName = 'medicalCenter';
    const user = JSON.parse(localStorage.getItem('token')!);
    if (user) {
      this.authService.fetchUser(user).subscribe(() => {});
    }
  }
}
